import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getMsalInstance } from './config/msalConfig';

// Initialize MSAL *before* React renders so that when the MSAL popup window
// loads this app (after Microsoft's redirect), handleRedirectPromise() runs
// and passes tokens back to the parent window before React Router can
// navigate away and strip the auth code from the URL.
getMsalInstance()
  .catch(() => {})
  .finally(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
